import React, { useState } from "react"
import { ChevronUp } from "react-feather"
import { Collapse, CardHeader, CardTitle } from "reactstrap"
import styles from "./CollapseWithChildren.module.scss"

function CollapseWithChildren({ title, children }) {
	const [isOpen, setIsOpen] = useState(false)

	return (
		<div className={`${styles.wrapper}`}>
			<CardHeader onClick={() => setIsOpen(!isOpen)} className={styles.header}>
				<CardTitle className="collapse-title">{title}</CardTitle>
				<ChevronUp
					size={14}
					className={`${styles.arrow} ${isOpen ? "" : styles.closed}`}
				/>
			</CardHeader>
			<Collapse isOpen={isOpen}>{children}</Collapse>
		</div>
	)
}

export default CollapseWithChildren
